import { type ReactNode } from "react";
import { useRegisterCapGo, useUpdateAvailableListener } from "./hooks";

export function CapGoUpdateProvider({ children }: { children: ReactNode }) {
  useRegisterCapGo();
  useUpdateAvailableListener();

  return <>{children}</>;
}
